(() => {
  angular
    .module('gm.common.services')
    .factory('GmyNotificationsWatcher', GmyNotificationsWatcher);

  function GmyNotificationsWatcher(
    GmyNotifications,
    GmyVaults,
    GmyUtils,
    btgUser
  ) {
    'ngInject';

    const _throttleVaultLoad = (() => GmyUtils
      .throttle(() => GmyVaults.getVaults(true), 1000)
    )();

    return {
      startWatchingNotifications,
    };

    function startWatchingNotifications() {
      GmyNotifications.onNotification(
        _throttleVaultLoad,
        [
          GmyNotifications.NOTIFICATION_TYPES.TRADE,
          GmyNotifications.NOTIFICATION_TYPES.TRADE_CONFIRMED
        ]
      );

      GmyNotifications.onNotification((data) => {
        // data.validationState.firstDepositBonus = Date.now()/1000 + 1000;
        // for First Deposit Bonus flow testing
        if (data && data.validationState) {
          btgUser.updateProfileLocally(data.validationState);
        }
      }, [GmyNotifications.NOTIFICATION_TYPES.USER_STATE]);
    }
  }
})();
